import { handleAction, handleActions } from "redux-actions";

import * as C from "./constants";

const initialState = {
  year: "",
  serialNumber: "",
  ssn: "",
  dueDateCount: "060",
  newCollateralNumber: "",
  currentCollateralNumber: "",
  sellerName: "",
  newCollateral: {},
  currentCollateral: {},
  collateralMilage: "",
  carInsuranceCompanies: [],
  communication: null,
  productType: "077",
  editable: true,
  validationError: "",
  collateralValue: 0,
  additionalCashDeposit: 0,
  initialDeposit: 0,
  depositPercentage: 0,
  redemption: 0,
  isFetchingConsolidationInfo: false,
  hasFetchedConsolidationInfo: false,
  isFetchingSaveConsolidation: false,
  hasFetchedSaveConsolidation: false,
  isFetchingCalculateConsolidation: false,
  hasFetchedCalculateConsolidation: false,
  isFetchingCarInfo: false,
  hasFetchedCarInfo: false,
  isFetchingConsolidationRmbal: false,
  hasFetchedConsolidationRmbal: false,
  isFetchingCurrentCarInfo: false,
  hasFetchedCurrentCarInfo: false,
  depositPercentage: 0
};

export default handleActions(
  {
    [C.RESET_CONSOLIDATION_STATE]: (state) => ({
      ...initialState,
      carInsuranceCompanies: state.carInsuranceCompanies, // Preserve loaded insurance companies
    }),
    [C.SET_NEW_COLLATERAL_ITEM]: (state, action) => ({
      ...state,
      newCollateralNumber: action.collateralItem,
      newCollateral: {
        ...state.newCollateral,
        collateralId: action.collateralItem,
      },
    }),
    [C.SET_CURRENT_COLLATERAL_ITEM]: (state, action) => ({
      ...state,
      currentCollateralNumber: action.collateralItem,
      currentCollateral: 
      {
        ...state.currentCollateral,
        collateralId: action.collateralItem
      }
    }),
    [C.SET_SSN]: (state, action) => ({
      ...state,
      ssn: action.ssn,
    }),
    [C.SET_MILAGE]: (state, { collateralMilage }) => ({
      ...state,
      collateralMilage: collateralMilage,
      newCollateral: 
      {
        ...state.newCollateral,
        milage: collateralMilage
      }
    }),
    [C.SET_NEW_COLLATERAL_AMOUNT]: (state, action) => ({
      ...state,
      newCollateral: {
        ...state.newCollateral,
        salesAmt: action.amount,
      },
    }),
    [C.SET_CURRENT_COLLATERAL_AMOUNT]: (state, action) => ({
      ...state,
      currentCollateral: {
        ...state.currentCollateral,
        salesAmt: action.amount,
      },
    }),
    [C.SET_COLLATERAL_REDEMPTION]: (state, action) => ({
      ...state,
      collateralRedemption: action.amount,
    }),
    [C.SET_COLLATERAL_REDEMPTION_AND_CLEAR_LICENSE_PLATE_CHANGED]: (state) => ({
      ...state,
      collateralRedemption: 0,
      year: "", 
      serialNumber: "",
    }),
    [C.SET_COLLATERAL_VALUE]: (state, action) => ({
      ...state,
      collateralValue: action.amount,
    }),
    [C.SET_ADDITIONAL_DEPOSIT]: (state, action) => ({
      ...state,
      additionalCashDeposit: action.amount,
    }),
    [C.SET_INITIAL_DEPOSIT]: (state, action) => ({
      ...state,
      initialDeposit: action.amount,
    }),
    [C.SET_TERMS_DUE_DATE_COUNT]: (state, action) => ({
      ...state,
      dueDateCount: action.dueDateCount,
    }),
    [C.CAR_INFO_REQUEST]: (state) => ({
      ...state,
      isFetchingCarInfo: true,
      hasFetchedCarInfo: false,
    }),
    [C.CAR_INFO_SUCCESS]: (state, { car }) => ({
      ...state,
      newCollateral: {
        ...state.newCollateral,
        collateralId: car.number,
        name: car.type,
        firstRegistrationDate: car.firstRegistration,
        category: car.category,
        operatorId: car.ownerRegistryId,
      },
      newCollateralNumber: car.number,
      car,
    }),
    [C.CAR_INFO_FAILURE]: (state, { error }) => ({
      ...state,
      isFetchingCarInfo: false,
      hasFetchedCarInfo: false,
      error,
    }),
    [C.GET_SELLER_NAME_SUCCESS]: (state, { name }) => ({
      ...state,
      sellerName: name,
      isFetchingCarInfo: false,
      hasFetchedCarInfo: true,
    }),
    [C.GET_PERSON_NAME_FAILURE]: (state, { error }) => ({
      ...state,
      error,
      isFetchingCarInfo: false,
      hasFetchedCarInfo: false,
    }),
    [C.GET_PERSON_NAME_REQUEST]: state => ({
      ...state,
      isFetchingCarInfo: true,
      hasFetchedCarInfo: false,
    }),
    [C.CONSOLIDATION_INFO_REQUEST]: (state) => ({
      ...state,
      isFetchingConsolidationInfo: true,
      hasFetchedConsolidationInfo: false
    }),
    [C.CONSOLIDATION_INFO_SUCCESS]: (state, { data }) => ({
      ...state,
      isFetchingConsolidationInfo: false,
      hasFetchedConsolidationInfo: true,
      ...(Object.keys(state).length === 0 && Object.keys(data).length > 0 ? data : {}),
      ...(Object.keys(state).length > 0 && Object.keys(data).length > 0 ? {
        year: data.year,
        serialNumber: data.serialNumber,
        status: data.status,
        subStatus: data.subStatus,
        statusText: data.statusText,
        editable: parseInt(data.status) < 10,
        productType: data.productType,
        productText: data.productText,
        initialDeposit: data.initialDeposit,
        additionalCashDeposit: data.additionalCashDeposit,
        commitmentFee: data.commitmentFee,
        commitmentFeePct: data.commitmentFeePct,
        commitmentFeeCategory: data.commitmentFeeCategory,
        registrationFee: data.registrationFee,
        registrationFeeClassification: data.registrationFeeClassification,
        administrationFee: data.administrationFee,
        administrationFeeClassification: data.administrationFeeClassification,
        finalFee: data.finalFee,
        loanNetAmount: data.loanNetAmount,
        paymentToSeller: data.paymentToSeller,
        dueDateCount: data.dueDateCount,
        firstDueDate: data.firstDueDate,
        interestRate: data.interestRate,
        annualCostRatio: data.annualCostRatio,
        plannedFirstPayment: data.plannedFirstPayment,
        plannedAveragePayment: data.plannedAveragePayment,
        currency: data.currency,
        disposalInformation: data.disposalInformation,
        sendContract: data.sendContract,
        sendDocument: data.sendDocument,
        sendDocumentCount: data.sendDocumentCount,
        message1: data.message1,
        message2: data.message2,
        conversation: data.conversation,
        documentPDF: data.documentPDF,
        collateralContractAssigned: data.collateralContractAssigned,
        collateralValue: data.collateralValue,
        collateralRedemption: data.collateralRedemption,
        resellerStaffId: data.resellerStaffId,
        resellerCompanyId: data.resellerCompanyId,
        applicants: data.applicants,
        currentCollateral: {
          ...data.currentCollateral,
          operatorId: data.currentCollateral?.operatorRegistryId
        },
        newCollateral: {
          ...data.newCollateral,
          operatorId: data.newCollateral?.operatorRegistryId
        },
        newCollateralNumber: data.newCollateral?.collateralId || state.newCollateralNumber,
        currentCollateralNumber: data.currentCollateral?.collateralId || state.currentCollateralNumber,
        collateralMilage: data.newCollateral?.milage || state.collateralMilage,
      } : {})
    }),
    [C.CONSOLIDATION_INFO_FAILURE]: (state, { error }) => ({
      ...state,
      error,
      isFetchingConsolidationInfo: false,
      hasFetchedConsolidationInfo: false
    }),

    [C.SAVE_CONSOLIDATION_REQUEST]: (state) => ({
      ...state,
      isFetchingSaveConsolidation: true,
      hasFetchedSaveConsolidation: false
    }),
    [C.SAVE_CONSOLIDATION_SUCCESS]: (state, { data }) => ({
      ...state,
      isFetchingSaveConsolidation: false,
      hasFetchedSaveConsolidation: true,
      ...(Object.keys(state).length === 0 && Object.keys(data).length > 0 ? data : {}),
      ...(Object.keys(state).length > 0 && Object.keys(data).length > 0 ? {
        year: data.year,
        serialNumber: data.serialNumber,
        status: data.status,
        subStatus: data.subStatus,
        statusText: data.statusText,
        editable: parseInt(data.status) < 10,
        productType: data.productType,
        productText: data.productText,
        initialDeposit: data.initialDeposit,
        additionalCashDeposit: data.additionalCashDeposit,
        commitmentFee: data.commitmentFee,
        commitmentFeePct: data.commitmentFeePct,
        commitmentFeeCategory: data.commitmentFeeCategory,
        registrationFee: data.registrationFee,
        registrationFeeClassification: data.registrationFeeClassification,
        administrationFee: data.administrationFee,
        administrationFeeClassification: data.administrationFeeClassification,
        finalFee: data.finalFee,
        loanNetAmount: data.loanNetAmount,
        paymentToSeller: data.paymentToSeller,
        dueDateCount: data.dueDateCount,
        firstDueDate: data.firstDueDate,
        interestRate: data.interestRate,
        annualCostRatio: data.annualCostRatio,
        plannedFirstPayment: data.plannedFirstPayment,
        plannedAveragePayment: data.plannedAveragePayment,
        currency: data.currency,
        disposalInformation: data.disposalInformation,
        sendContract: data.sendContract,
        sendDocument: data.sendDocument,
        sendDocumentCount: data.sendDocumentCount,
        message1: data.message1,
        message2: data.message2,
        conversation: data.conversation,
        documentPDF: data.documentPDF,
        collateralContractAssigned: data.collateralContractAssigned,
        collateralValue: data.collateralValue,
        collateralRedemption: data.collateralRedemption,
        resellerStaffId: data.resellerStaffId,
        resellerCompanyId: data.resellerCompanyId,
        applicants: data.applicants,
        currentCollateral: {
          ...data.currentCollateral,
          operatorId: data.currentCollateral?.operatorRegistryId
        },
        newCollateral: {
          ...data.newCollateral,
          operatorId: data.newCollateral?.operatorRegistryId
        },
        collateralMilage: data.newCollateral?.milage || state.collateralMilage,
      } : {})
    }),
    [C.SAVE_CONSOLIDATION_FAILURE]: (state, { error }) => ({
      ...state,
      error,
      isFetchingSaveConsolidation: false,
      hasFetchedSaveConsolidation: false
    }),

    [C.CALCULATE_CONSOLIDATION_REQUEST]: (state) => ({
      ...state,
      isFetchingCalculateConsolidation: true,
      hasFetchedCalculateConsolidation: false
    }),
    [C.CALCULATE_CONSOLIDATION_SUCCESS]: (state, { data }) => ({
      ...state,
      isFetchingCalculateConsolidation: false,
      hasFetchedCalculateConsolidation: true,
      ...(Object.keys(state).length > 0 && Object.keys(data).length > 0 ? {
        year: data.year,
        serialNumber: data.serialNumber,
        status: data.status,
        subStatus: data.subStatus,
        statusText: data.statusText,
        productType: data.productType,
        productText: data.productText,
        commitmentFee: data.commitmentFee,
        commitmentFeePct: data.commitmentFeePct,
        commitmentFeeCategory: data.commitmentFeeCategory,
        registrationFee: data.registrationFee,
        registrationFeeClassification: data.registrationFeeClassification,
        administrationFee: data.administrationFee,
        administrationFeeClassification: data.administrationFeeClassification,
        finalFee: data.finalFee,
        loanNetAmount: data.loanNetAmount,
        paymentToSeller: data.paymentToSeller,
        dueDateCount: data.dueDateCount,
        firstDueDate: data.firstDueDate,
        interestRate: data.interestRate,
        annualCostRatio: data.annualCostRatio,
        plannedFirstPayment: data.plannedFirstPayment,
        plannedAveragePayment: data.plannedAveragePayment,
        currency: data.currency,
        disposalInformation: data.disposalInformation,
        sendContract: data.sendContract,
        sendDocument: data.sendDocument,
        sendDocumentCount: data.sendDocumentCount,
        message1: data.message1,
        message2: data.message2,
        conversation: data.conversation,
        documentPDF: data.documentPDF,
        collateralContractAssigned: data.collateralContractAssigned,
        resellerStaffId: data.resellerStaffId,
        resellerCompanyId: data.resellerCompanyId,
        applicants: data.applicants,
        currentCollateral: {
          ...state.currentCollateral,
          ...data.currentCollateral,
          salesAmt: state.currentCollateral.salesAmt,
          collateralId: state.currentCollateral.collateralId,
        },
        newCollateral: {
          ...state.newCollateral,
          ...data.newCollateral,
          salesAmt: state.newCollateral.salesAmt,
          collateralId: state.newCollateral.collateralId,
        }
      } : {})
    }),
    [C.CALCULATE_CONSOLIDATION_FAILURE]: (state, { error }) => ({
      ...state,
      error,
      isFetchingCalculateConsolidation: false,
      hasFetchedCalculateConsolidation: false
    }),

    [C.GET_CONSOLIDATION_RMBAL_REQUEST]: (state) => ({
      ...state,
      isFetchingConsolidationRmbal: true,
      hasFetchedConsolidationRmbal: false
    }),
    [C.GET_CONSOLIDATION_RMBAL_SUCCESS]: (state, { data }) => ({
      ...state,
      isFetchingConsolidationRmbal: false,
      hasFetchedConsolidationRmbal: true,
      ...(Object.keys(state).length > 0 && Object.keys(data).length > 0 ? {
        year: data.year,
        serialNumber: data.serialNumber,
        status: data.status,
        subStatus: data.subStatus,
        statusText: data.statusText,
        productType: data.productType,
        productText: data.productText,
        commitmentFee: data.commitmentFee,
        commitmentFeePct: data.commitmentFeePct,
        commitmentFeeCategory: data.commitmentFeeCategory,
        registrationFee: data.registrationFee,
        registrationFeeClassification: data.registrationFeeClassification,
        administrationFee: data.administrationFee,
        administrationFeeClassification: data.administrationFeeClassification,
        finalFee: data.finalFee,
        loanNetAmount: data.loanNetAmount,
        paymentToSeller: data.paymentToSeller,
        dueDateCount: data.dueDateCount,
        firstDueDate: data.firstDueDate,
        interestRate: data.interestRate,
        annualCostRatio: data.annualCostRatio,
        plannedFirstPayment: data.plannedFirstPayment,
        plannedAveragePayment: data.plannedAveragePayment,
        currency: data.currency,
        disposalInformation: data.disposalInformation,
        sendContract: data.sendContract,
        sendDocument: data.sendDocument,
        sendDocumentCount: data.sendDocumentCount,
        message1: data.message1,
        message2: data.message2,
        conversation: data.conversation,
        documentPDF: data.documentPDF,
        collateralContractAssigned: data.collateralContractAssigned,
        collateralRedemption: data.collateralRedemption,
        resellerStaffId: data.resellerStaffId,
        resellerCompanyId: data.resellerCompanyId,
        applicants: data.applicants,
        currentCollateral: {
          ...state.currentCollateral,
          ...data.currentCollateral,
          salesAmt: state.currentCollateral.salesAmt,
          collateralId: state.currentCollateral.collateralId,
        },
        newCollateral: {
          ...state.newCollateral,
          ...data.newCollateral,
          salesAmt: state.newCollateral.salesAmt,
          collateralId: state.newCollateral.collateralId,
        }
      } : {})
    }),
    [C.GET_CONSOLIDATION_RMBAL_FAILURE]: (state, { error }) => ({
      ...state,
      error,
      isFetchingConsolidationRmbal: false,
      hasFetchedConsolidationRmbal: false
    }),

    [C.SET_CAR_INSURANCE_COMPANY]: (state, { insuranceCompanyId }) => ({
      ...state,
      newCollateral: {
        ...state.newCollateral,
        insuranceCompanyId: insuranceCompanyId,
      },
    }),
    [C.SET_CAR_INSURANCE_COMPANIES]: (state, { carInsuranceCompanies }) => ({
      ...state,
      carInsuranceCompanies,
    }),

    [C.CURRENT_CAR_INFO_REQUEST]: (state) => ({
      ...state,
      isFetchingCurrentCarInfo: true,
      hasFetchedCurrentCarInfo: false,
    }),
    [C.CURRENT_CAR_INFO_SUCCESS]: (state, { car }) => ({
      ...state,
      currentCollateral: {
        ...state.currentCollateral,
        collateralId: car.number,
        name: car.type,
        firstRegistrationDate: car.firstRegistration,
        category: car.category,
        operatorId: car.ownerRegistryId,
      },
      currentCollateralNumber: car.number,
      isFetchingCurrentCarInfo: false,
      hasFetchedCurrentCarInfo: true,
    }),
    [C.CURRENT_CAR_INFO_FAILURE]: (state, { error }) => ({
      ...state,
      isFetchingCurrentCarInfo: false,
      hasFetchedCurrentCarInfo: false,
      error,
    }),

    [C.SET_DEPOSIT_PERCENTAGE]: (state, { percentage }) => ({
      ...state,
      depositPercentage: percentage,
    }),

    [C.SET_LOAN_TYPE]: (state, action) => ({
      ...state,
      productType: action.productType
    }),

    [C.CLEAR_RMBAL_FLAGS]: (state) => ({
      ...state,
      hasFetchedConsolidationRmbal: false,
      hasFetchedCalculateConsolidation: false,
      hasFetchedConsolidationInfo: false,
      // Clear consolidation applicant data that gets populated by API responses
      applicant: undefined,
      secondApplicant: undefined,
      guarantor: undefined,
      secondGuarantor: undefined,
      guarantor2: undefined,
      applicants: [],
    }),
  },
  initialState
);
